import { render, staticRenderFns } from "./satisquestionDetails.vue?vue&type=template&id=009d7b8a&"
import script from "./satisquestionDetails.vue?vue&type=script&lang=js&"
export * from "./satisquestionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports